import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-18" data-mp="3c3yysrhwio94">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? "text-gold-300" : "text-navy-800"}`} data-id="element-19" data-mp="3h2a9t5jxn4sx">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="3729l143anwhc" />
        Special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-21" data-mp="10c3fvob1vu32">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-22" data-mp="15adbg00oswp7" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="159byfq04204u">
              <span className={`flex h-[72px] w-[78px] items-center justify-center rounded-xl font-serif text-4xl font-bold tabular-nums sm:h-20 sm:w-24 sm:text-5xl ${dark ? "bg-gold-400 text-navy-950" : "bg-navy-900 text-gold-300"}`} data-id="element-24" data-mp="y04yyajilyu7">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-navy-100/70" : "text-muted"}`} data-id="element-25" data-mp="f1sn2h17yaux">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? "text-gold-300" : "text-navy-900"}`} data-id="element-26" data-mp="o4k2erx7tqru">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}